/**
 *
 * @module drmClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef DrmClientEndpoint
 * @type {Object}
 *
 * @property {String} silkKey
 * @property {String} fairPlayCertificate
 * @property {String} fairPlayLicense
 * @property {String} widevineCertificate
 * @property {String} widevineLicense
 * @property {String} playReadyLicense
 *
 */

/**
 *
 * @enum
 * @type {DrmClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    silkKey: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    fairPlayCertificate: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    fairPlayLicense: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    widevineCertificate: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    widevineLicense: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    playReadyLicense: null
});



// WEBPACK FOOTER //
// ./src/services/drm/drmClientEndpoint.js